import React, { FC } from 'react';
import { Button, Input, Select, TextArea } from '@ui';
import useTranslation from '@app/hooks/use-translation';
import {
  useCreateCommandMutation,
  useEditCommandMutation,
} from '@app/store/api/qm-module/qm-manage/qm-manage-commands.api';
import { useForm } from 'react-hook-form';
import {
  QmCommandCreateType,
  QmCommandsListType,
} from '@app/interfaces/qm-module/qm-manage/qm-commands.type';
import { QmUsersListWithRolesType } from '@app/interfaces/qm-users.type';
import { OptionItem } from '@app/components/ui/select/select.type';
import {
  formBaseButtonBlockStyles,
  formBaseContainerStyles,
  formFieldBaseStylesModal650,
  formFieldNameBaseStyles,
} from '@app/styles/base-styles';

type QmCommandFormPropsType = {
  onClose?(): void;
  usersWithRolesList: QmUsersListWithRolesType['qm_users'] | undefined;
  commandFormData?: QmCommandsListType;
};

const QmCommandForm: FC<QmCommandFormPropsType> = (props) => {
  const { onClose, usersWithRolesList, commandFormData } = props;
  const { t } = useTranslation('pages.qmManage.commands.create_command_form');
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<QmCommandCreateType>({
    defaultValues: {
      name: commandFormData?.name,
      supervisor: commandFormData?.supervisor?.user_id,
      description: commandFormData?.description,
    },
  });
  // api
  const [createNewCommand] = useCreateCommandMutation();
  // eslint-disable-next-line
  const [editCommand] = useEditCommandMutation();
  // api
  function onSubmit(data: QmCommandCreateType) {
    commandFormData
      ? commandFormData?.team_id &&
        editCommand({ params: { team_id: commandFormData?.team_id }, body: data })
          .unwrap()
          .finally(() => onClose?.())
      : createNewCommand(data)
          .unwrap()
          .finally(() => onClose?.());
  }

  const supervisorOptionsList: OptionItem[] =
    usersWithRolesList?.map((user) => ({
      title: user.username,
      value: user.id,
    })) || [];

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={formBaseContainerStyles} action="">
      <div className={formFieldBaseStylesModal650}>
        <LabelMiniJsx label={t('name')} />
        <Input
          {...register('name', { required: { value: true, message: ' ' } })}
          error={errors.name?.message}
        />
      </div>
      <div className={formFieldBaseStylesModal650}>
        <LabelMiniJsx label={t('description')} />
        <TextArea {...register('description')} height={110} />
      </div>
      <div className={formFieldBaseStylesModal650}>
        <LabelMiniJsx label={t('supervisor')} />
        <Select
          withSearch
          options={supervisorOptionsList}
          defaultValue={watch('supervisor')}
          dropHeight={100}
          onChange={(value) => setValue('supervisor', String(value))}
        />
      </div>
      <div className={formBaseButtonBlockStyles}>
        <Button type="submit" label={t('approve_button')} />
        <Button fill="linked" onClick={onClose} label={t('cancel_button')} />
      </div>
    </form>
  );
};

export default QmCommandForm;

const LabelMiniJsx = (props: { label: string }) => {
  return <span className={formFieldNameBaseStyles}>{props.label}</span>;
};
